import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/map1.png'
import _imports_1 from '../../assets/icon/map-car.png'
import _imports_2 from '../../assets/icon/map-icon1.png'
import _imports_3 from '../../assets/icon/map-icon2.png'


const _withScopeId = n => (_pushScopeId("data-v-58805782"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "map-bg",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign1-1" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign2-1" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign3-1" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign4-1" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign5-1" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-ct" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font1" }, "50分钟")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font2" }, "距离苏州工业园区40公里", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-ct" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font1" }, "50分钟")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font2" }, "距离昆山小核酸产业基地28公里", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-ct" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font1" }, "30分钟")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font2" }, "距离昆山市人民政府26公里", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-ct" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font1" }, "30分钟")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font2" }, "距离虹桥国际机场37公里", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-ct" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font1" }, "25分钟")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font2" }, "距离华为研发中心21公里", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"suspension-box suspension-box6\" data-v-58805782><div class=\"flex-ct\" data-v-58805782><img class=\"icon\" src=\"" + _imports_2 + "\" alt=\"\" data-v-58805782><div class=\"font1\" data-v-58805782>10分钟</div></div><div class=\"font2\" data-v-58805782>距离附近任意高速</div></div><div class=\"suspension-box suspension-box7\" data-v-58805782><div class=\"flex-ct\" data-v-58805782><img class=\"icon\" src=\"" + _imports_3 + "\" alt=\"\" data-v-58805782><div class=\"font1\" data-v-58805782>长三角C位</div></div><div class=\"font2\" data-v-58805782>长三角区域核心位置</div></div>", 2)

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const hover_sign = ref<string | null>(null);
const is_move = ref(window.innerWidth < 600);
function changeStyle(sign: string, isHovered: boolean) {
  if (is_move.value) {
    return;
  }
  hover_sign.value = isHovered ? sign : null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "sign1",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (changeStyle('sign1', true))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (changeStyle('sign1', false)))
      }, _hoisted_4, 32),
      _createElementVNode("div", {
        class: "sign2",
        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (changeStyle('sign2', true))),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (changeStyle('sign2', false)))
      }, _hoisted_6, 32),
      _createElementVNode("div", {
        class: "sign3",
        onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (changeStyle('sign3', true))),
        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (changeStyle('sign3', false)))
      }, _hoisted_8, 32),
      _createElementVNode("div", {
        class: "sign4",
        onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (changeStyle('sign4', true))),
        onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (changeStyle('sign4', false)))
      }, _hoisted_10, 32),
      _createElementVNode("div", {
        class: "sign5",
        onMouseenter: _cache[8] || (_cache[8] = ($event: any) => (changeStyle('sign5', true))),
        onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (changeStyle('sign5', false)))
      }, _hoisted_12, 32)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(
          hover_sign.value === 'sign1'
            ? 'suspension-box suspension-box1 hover-now'
            : 'suspension-box suspension-box1'
        )
      }, _hoisted_15, 2),
      _createElementVNode("div", {
        class: _normalizeClass(
          hover_sign.value === 'sign2'
            ? 'suspension-box suspension-box2 hover-now'
            : 'suspension-box suspension-box2'
        )
      }, _hoisted_18, 2),
      _createElementVNode("div", {
        class: _normalizeClass(
          hover_sign.value === 'sign3'
            ? 'suspension-box suspension-box3 hover-now'
            : 'suspension-box suspension-box3'
        )
      }, _hoisted_21, 2),
      _createElementVNode("div", {
        class: _normalizeClass(
          hover_sign.value === 'sign4'
            ? 'suspension-box suspension-box4 hover-now'
            : 'suspension-box suspension-box4'
        )
      }, _hoisted_24, 2),
      _createElementVNode("div", {
        class: _normalizeClass(
          hover_sign.value === 'sign5'
            ? 'suspension-box suspension-box5 hover-now'
            : 'suspension-box suspension-box5'
        )
      }, _hoisted_27, 2),
      _hoisted_28
    ])
  ]))
}
}

})